import { forwardRef } from "react";

type ReceiptProps = {
  amount: string;
  transactionId: string;
  balance: string;
  studentInfo: string;
  receiptId: string;
  schoolName?: string;
  studentId?: string;
  type?: 'tuition' | 'daycare' | 'cab'; // Add type prop
  parentName?: string;
  transactionDate?: string;
};

const typeToStyle = {
  tuition: {
    bg: 'bg-cyan-50',
    label: 'Tuition Fees',
  },
  daycare: {
    bg: 'bg-red-50',
    label: 'Daycare Fees',
  },
  cab: {
    bg: 'bg-yellow-50',
    label: 'Cab Fees',
  },
};

const Receipt = forwardRef<HTMLDivElement, ReceiptProps>(
  ({ amount, transactionId, balance, studentInfo, receiptId, schoolName = 'Euro Wis', studentId, type = 'tuition', parentName, transactionDate }, ref) => {
    const style = typeToStyle[type] || typeToStyle['tuition'];
    const formattedDate = transactionDate
      ? new Date(transactionDate).toLocaleString('en-IN', {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
        })
      : '';
    return (
      <div
        ref={ref}
        className={`w-[800px] mx-auto p-6 border border-black text-sm text-black bg-white ${style.bg}`}
      >
        {/* Header */}
        <img src="./assets/logo.png" alt="logo" height={70} width={70} />
        <div className="text-center border-b border-black pb-4 flex flex-col items-center gap-2">
          <h2 className="text-xl font-semibold">{schoolName}</h2>
          <p className="text-sm text-center" style={{maxWidth: '40ch'}}>Plot No 4, Sushila Nagar, Rajiv Gandhi Salai, OMR, Opposite to KFC, Tiruporur Tk, Kelambakkam, Chennai 603103</p>
        </div>
        {/* Fee Type Header */}
        <div className="text-center my-4">
          <span className="inline-block h-10 px-4 py-1 rounded font-bold text-base border border-black bg-white/70" style={{letterSpacing: '0.05em'}}>{style.label}</span>
        </div>
        {/* Transaction Info */}
        <div className="my-8 px-4">
          <table className="w-full border text-center">
            <thead>
              <tr className="font-semibold">
                <th className="border px-4 py-2">AMOUNT</th>
                <th className="border px-4 py-2">RECEIPT ID</th>
                <th className="border px-4 py-2">BALANCE</th>
                <th className="border px-4 py-2">DATE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border px-4 py-2">{amount}</td>
                <td className="border px-4 py-2">{transactionId}</td>
                <td className="border px-4 py-2">{balance}</td>
                <td className="border px-4 py-2">{formattedDate || '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* Student Info */}
        <div className="border-b border-black py-4">
          <p className="font-bold mb-2">Student Info</p>
          <div className="pl-4 whitespace-pre-line">{studentInfo}</div>
          {studentId && (
            <div className="pl-4 text-s text-gray-600">Student Registration No: {studentId}</div>
          )}
          {parentName && (
            <div className="pl-4 text-s">Parent Name: {parentName}</div>
          )}
        </div>
        {/* Footer */}
        <div className="flex justify-between mt-2 items-end pt-12">
          <p className="font-medium">Receipt id: {receiptId}</p>
          <div className="flex flex-col items-center gap-2">
            <img src="./assets/school_seal.png" alt="School Seal" className="w-36 h-12 object-contain" />
            <p className="font-medium">Signature</p>
          </div>
        </div>
      </div>
    );
  }
);

export default Receipt; 